module.exports = __webpack_public_path__ + "static/img/traffic-light-green.6a96066.png";